/**
 * UserStatusBadge — badge visual para status do usuário.
 * Opção A: silent, sem throw — badge neutral se status desconhecido.
 */

const STATUS_STYLE: Record<string, string> = {
  active: 'bg-green-100 text-green-800',
  archived: 'bg-gray-100 text-gray-600',
  suspended: 'bg-yellow-100 text-yellow-800',
  on_leave: 'bg-blue-100 text-blue-700',
  inactive: 'bg-gray-100 text-gray-500',
};

const STATUS_LABEL: Record<string, string> = {
  active: 'Ativo',
  archived: 'Desativado',
  suspended: 'Suspenso',
  on_leave: 'Em licença',
  inactive: 'Inativo',
};

interface Props {
  status: string;
}

export function UserStatusBadge({ status }: Props): JSX.Element {
  const cls = STATUS_STYLE[status] ?? 'bg-gray-100 text-gray-500';
  const label = STATUS_LABEL[status] ?? status;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${cls}`}
    >
      {label}
    </span>
  );
}
